export const config: TConfig = {
	defaultLanguage: 'pl',
	availableLanguages: ['pl', 'en', 'ua'] as TLanguage[],
	selectableLanguages: ['en', 'ua'],

	sellingPriceTaxRate: 0.08,
	priceToPointsCoefficient: 20,
}
